// Filters the row matching `id` out of every cached library items query under `scope`
// (React Query infinite data from useGetLibraryItems), keyword variants included. The tab
// badge and the "N more" hint read meta.totalCount, so it drops with the row; a query
// that never held the row keeps its count.
function removeFromLibraryCache(queryClient, scope, id) {
  if (!queryClient?.setQueriesData || id == null) {
    return
  }

  const itemKey = String(id)

  queryClient.setQueriesData(
    {
      predicate: (query) => Array.isArray(query.queryKey)
        && query.queryKey[0] === 'libraryItems'
        && query.queryKey[1] === scope,
    },
    (oldData) => {
      if (oldData == null || !Array.isArray(oldData.pages)) {
        return oldData
      }

      const pages = oldData.pages.map((page) => ({
        ...page,
        items: (page.items || []).filter((item) => item != null && String(item.id) !== itemKey),
      }))
      const wasRemoved = pages.some((page, index) => (
        page.items.length !== (oldData.pages[index].items || []).filter((item) => item != null).length
      ))

      if (!wasRemoved) {
        return { ...oldData, pages }
      }

      return {
        ...oldData,
        pages: pages.map((page) => (
          typeof page.meta?.totalCount === 'number'
            ? { ...page, meta: { ...page.meta, totalCount: Math.max(0, page.meta.totalCount - 1) } }
            : page
        )),
      }
    },
  )
}

/**
 * Removes the session row matching `sessionId` from every cached 3D library items
 * query and lowers its total count. Does not refetch.
 *
 * @param {import('@tanstack/react-query').QueryClient} queryClient
 * @param {{ sessionId: string|number }} params
 */
export function removeSessionFromLibraryCache(queryClient, { sessionId }) {
  removeFromLibraryCache(queryClient, 'sessions', sessionId)
}

/**
 * Removes the image run row matching `runId` from every cached Images library items
 * query and lowers its total count. Does not refetch.
 *
 * @param {import('@tanstack/react-query').QueryClient} queryClient
 * @param {{ runId: string|number }} params
 */
export function removeImageRunFromLibraryCache(queryClient, { runId }) {
  removeFromLibraryCache(queryClient, 'images', runId)
}
